export type Dosen = {
  dosen_id: number;
  no_induk_undiksha: string;
  nama: string;
  nidn: string;
  nip?: string;
  email?: string;
  status_serdos?: number;
  photo?: string;
  riwayat_struktural?: any | null;
  riwayat_fungsional?: any[];
};

export type DosenResponse = {
  datas: Dosen[];
  is_next: boolean;
  status: string;
};

import { apiClient } from "@/lib/api-client";

export const fetchDosen = async ({ pageParam = 1, limit = 10 }: { pageParam?: number, limit?: number } = {}): Promise<DosenResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  // Token Authorization sementara sesuai implementasi terakhir
  return apiClient<DosenResponse>(`${baseUrl}/api/v1/master-dosen?page=${pageParam}&limit=${limit}`);
};
